import { render } from "./EditFaqPage.vue?vue&type=template&id=4242f52e&ts=true"
import script from "./EditFaqPage.vue?vue&type=script&lang=ts"
export * from "./EditFaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__